export const REPORT_LIST_REQUEST = 'REPORT_LIST_REQUEST'
export const REPORT_REQUEST = 'REPORT_REQUEST'
export const REPORT_SUCCESS = 'REPORT_SUCCESS'
export const REPORT_ERROR = 'REPORT_ERROR'
